import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';

class JoinedCourses extends Component {

    componentDidMount() {
        this.props.joinedCourses && this.props.joinedCourses.length && this.props.joinedCourses.map((data, index) => {
            return this.props.courseId(data._id)
        })
    }
    
    render() {
        return (
            <Paper className="joinedCourses">
                <Table>
                    <TableHead style={{ backgroundColor: "#13a89e" }}>
                        <TableRow><TableCell style={{ color: "white", fontSize: "large", fontWeight: "bold" }}>Your Course's</TableCell></TableRow></TableHead>
                    <TableBody>{this.props.joinedCourses && this.props.joinedCourses.length ? this.props.joinedCourses.map((data, index) => {
                        return <TableRow key={index}><TableCell style={{ fontSize: "14px" }}><Link className="joinedCourses-table-text" to={{ pathname: `/course/${data.secondName !== undefined ? data.secondName : data.name.toLowerCase().replace(/\s/g, "-")}`, state: { index: 0, course: data, user: this.props.user } }}>{data.name}</Link></TableCell></TableRow>
                    }) : <TableRow><TableCell>No Joined Course's Available</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

export default JoinedCourses;


// WEBPACK FOOTER //
// ./src/container/JoinedCourses/joinedcourses.js